export const COOKIE_TRANSFER_TYPE_EMAIL = '1';

export const COOKIE_TRANSFER_TYPE_LINK = '4';
